import { TextPartHighlight } from '@components/Sections/Sections.styled';

import {
  MainTextStyled,
  TextPenOutline,
  TextPenUnderlineSmall,
  TextPenUnderlineFirst,
  TextPenUnderlineSecond,
} from './MainText.styled';

export const MainText: React.FC = () => {
  return (
    <>
      <MainTextStyled>
        We believe that one of the main problems in the still ongoing discussions surrounding the representation of
        women in esports is{' '}
        <TextPartHighlight>
          the&nbsp;lack
          <TextPenOutline
            isFullCentered
            width="147"
            height="46"
            viewBox="0 0 147 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.4234 10.7716C-1.73373 3.2245 -0.324632 22.3863 2.46735 29.8127C10.1869 47.5898 51.3525 44.6347 76.5815 44.6347C115.353 42.097 148.373 42.5917 145.767 22.0227C139.696 -10.8495 35.8459 3.82385 22.2019 7.05613C12.0692 9.4566 5.71124 14.1168 4.9886 15.7643"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenOutline>
          <TextPenUnderlineSmall
            width="93"
            height="6"
            viewBox="0 0 93 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4.7749C13.2519 4.90633 25.6941 3.03494 37.9117 4.00633C48.1365 4.81927 57.8778 2.1673 68.1662 2.27767C76.1334 2.36313 83.5366 1.88507 91.4277 1.96972"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderlineSmall>
        </TextPartHighlight>{' '}
        <TextPartHighlight>
          of&nbsp;information
          <TextPenUnderlineFirst
            width="237"
            height="9"
            viewBox="0 0 237 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 7.37354C32.7789 7.63005 65.0512 3.97439 96.7412 5.87163C123.262 7.45941 148.529 2.27906 175.215 2.49447C195.88 2.66128 215.083 1.72734 235.55 1.89256"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderlineFirst>
        </TextPartHighlight>{' '}
        and awareness of the causes that deter female gamers at their first steps in gaming, and the factors that
        inhibit women from advancing from amateur status to the professional level.
      </MainTextStyled>
      <MainTextStyled>
        We attempted to compile the available academic publications, monographs, and public reports on these issues.
        During 2021 with the support and help of academic researchers we interviewed a number of professional gamers and
        experts from Brazil, Canada, Ukraine, and the U.S. to contribute{' '}
        <TextPartHighlight>
          their&nbsp;side&nbsp;of&nbsp;the&nbsp;story
          <TextPenUnderlineSecond
            width="350"
            height="8"
            viewBox="0 0 350 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M348.209 6.37354C301.163 6.75329 253.401 3.22266 206.479 5.24286C167.211 6.93353 129.826 1.851 90.319 2.16989C59.7251 2.41685 31.3013 1.55734 1.00002 1.80193"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderlineSecond>
        </TextPartHighlight>
        , and to convey their perspective to the gaming community at large.
      </MainTextStyled>
    </>
  );
};
